/* eslint-disable max-len */
export const RUSSIAN_SOFTWARE_REGISTRY_HREF =
  'https://reestr.digital.gov.ru/reestr/3508245/?sphrase_id=6549530';

export const RUSSIAN_SOFTWARE_REGISTRY_NUMBER = '№28868 от 28.07.2025';

export const RUSSIAN_SOFTWARE_REGISTRY_DESCRIPTION = `Система находится в реестре отечественного ПО ${RUSSIAN_SOFTWARE_REGISTRY_NUMBER}`;
